import {useContext, useEffect} from 'react'
import ReactGA from 'react-ga'
import useGlobalPrivacyControl from "Hooks/useGlobalPrivacyControl";
import { TrackingContext } from 'Contexts/TrackingContext/TrackingContext'

const initializeGoogleAnalytics = () => {

    const { isGpcEnabled } = useGlobalPrivacyControl()
    const trackingContext = useContext(TrackingContext)

    useEffect(() => {
        if(!isGpcEnabled) {

            const gaTrackingCode_production = 'UA-1304597-1'
            const gaTrackingCode_staging = 'UA-1304597-10'
            const gaTrackingCode_dev_qa = 'UA-1304597-12'

            let gaTrackingCode
            let googleOptimizeContainerId

            switch (window.location.hostname) {
                case 'www.speedwaymotors.com':
                case 'test.speedwaymotors.com':
                    gaTrackingCode = gaTrackingCode_production
                    break
                case 'staging.speedway2.com':
                case 'staging-alt.speedway2.com':
                    gaTrackingCode = gaTrackingCode_staging
                    break
                case 'qa.speedway2.com':
                case 'qa-alt.speedway2.com':
                    gaTrackingCode = gaTrackingCode_dev_qa
                    break
                default:
                    gaTrackingCode = gaTrackingCode_dev_qa
                    break
            }

            ReactGA.initialize(gaTrackingCode, {
                gaOptions: {
                allowLinker: true
                },
            })

            ReactGA.ga('require', 'linker');
            ReactGA.ga('linker:autoLink', ['app.maker.co']); 

            ReactGA.plugin.require('ec')

            window.dispatchEvent(new CustomEvent('googleAnalyticsLoaded', null))
            trackingContext.setGoogleAnalyticsReady()
        }

        return;

    }, [isGpcEnabled])

    return;
}

export default initializeGoogleAnalytics
